import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type BusinessTypeProps = {
  index: number
}

export const BusinessType = ({ index }: BusinessTypeProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.businessType`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="10. Occupation or type of business" input={(props) => <TextInput {...props} />} />
      )}
    />
  )
}
